import {Link} from 'react-router-dom'
import {ListsWidget5} from '../../../../_metronic/partials/widgets'
import StackedGraph from '../../../customPartials/stackedBarChart/StackedGraph'
import {useEffect, useState} from 'react'
import {getAllUserAppointmentExcelResult, getCourseBatchResult, getCourseExcelResult} from '../../../../Adaptor/TUBSIS'
import {GetCourseBatchDto} from '../../../../Adaptor/TUBSIS/controllers/Courses/models/getCourseBatchResult'

const Consultant = () => {
  const [userList, setUserList] = useState<GetCourseBatchDto | null>(null)
  const [selectedExcelType, setSelectedExcelType] = useState<number>(1)
  useEffect(() => {
    getCourseBatchResult()
      .then((response) => {
        ////debugger
        setUserList(response.data)
      })
      .catch((error) => {
        ////debugger
        console.log(error)
      })
  }, [])
  const clickExcel = () => {
    if (parseInt(selectedExcelType.toString()) === 4) {
      getAllUserAppointmentExcelResult(4)
    }
    else{
     getCourseExcelResult(selectedExcelType)
    }
  }
  const handleSelectChange = (e: any) => {
    setSelectedExcelType(e.target.value)
  }
  return (
    <>
      <div className='row'>
        <div className='col-2'>
          <select id='' onChange={handleSelectChange}>
            <option key='1' value='1'>
              Kayıt Esnasındaki Genel Bilgiler
            </option>
            <option key='2' value='2'>
              Test Sonuc
            </option>
            <option key='3' value='3'>
              Günlük Sigara Kullanımı
            </option>
            <option key='4' value='4'>
              Danışan Bilgileri
            </option>
          </select>
        </div>

        <div className='col-2'>
          <button onClick={clickExcel}>Excel'i İndir</button>
        </div>

        <div className='col-8'></div>
      </div>
      <div className='row g-5 g-xl-12'>
        <StackedGraph
          title={'MODUL TAMAMLAMA GRAFİK'}
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.tubsisWomenCompleteCount ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.tubsisMenCompleteCount ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.tubsisOtherCompleteCount ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
            },
            plotOptions: {
              bar: {
                horizontal: true,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'TÜBSİS - Modül Tamamlayan Kişi Sayısı',
            },
            xaxis: {
              categories: userList?.tubsisModulesNameList,
              labels: {
                formatter: function (val) {
                  const num = parseFloat(val);
                  return num.toFixed(1).toString()
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Kişi`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        />
        <StackedGraph
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.polsisWomenCompleteCount ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.polsisMenCompleteCount ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.polsisOtherCompleteCount ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
            },
            plotOptions: {
              bar: {
                horizontal: true,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'POLSİS - Modül Tamamlayan Kişi Sayısı',
            },
            xaxis: {
              categories: userList?.polsisModulesNameList ?? ['GİRİŞ', '4.MODÜL', '8.MODÜL'],
              labels: {
                formatter: function (val) {
                  //console.log("xekseni",val)
                  const num = parseFloat(val);
                  return num.toFixed(1).toString()
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Kişi`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        />
        <StackedGraph
          title={'MODUL TAMAMLAMA GRAFİK'}
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.sbpWomenUserAppointmentCount ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.sbpManUserAppointmentCount ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.sbpOtherUserAppointmentCount ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
            },
            plotOptions: {
              bar: {
                horizontal: true,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'SBP - Randevu Sayısı',
            },
            xaxis: {
              categories: ['Birinci Randevu', 'Kontrol Randevusu'],
              labels: {
                formatter: function (val) {
                  const num = parseFloat(val);
                  return num.toFixed(1).toString()
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Kişi`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        />
        <StackedGraph
          title={'MODUL TAMAMLAMA GRAFİK'}
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.sbpWomenUserCount ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.sbpManUserCount ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.sbpOtherUserCount ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
            },
            plotOptions: {
              bar: {
                horizontal: true,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'SBP - Kişi Sayısı',
            },
            xaxis: {
              categories: userList?.sbpUserCountCourseNames ?? ['TÜBSİS', 'POLSİS', 'SBP'],
              labels: {
                formatter: function (val) {
                  const num = parseFloat(val);
                  return num.toFixed(1).toString()
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Kişi`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        />
        {/* <StackedGraph
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.womenFNBTScore ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.menFNBTScore ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.otherFNBTScore ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0,
                  },
                },
              },
            ],
            plotOptions: {
              bar: {
                horizontal: false,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'FNBT ORTALAMA GRAFİK',
            },
            xaxis: {
              categories: userList?.modulesNameList,
              labels: {
                formatter: function (val) {
                  return val
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Puan`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        /> */}
        {/* <StackedGraph
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.womenWEMIOOScore ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.menWEMIOOScore ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.otherWEMIOOScore ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0,
                  },
                },
              },
            ],
            plotOptions: {
              bar: {
                horizontal: false,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'WEMİOÖ ORTALAMA GRAFİK',
            },
            xaxis: {
              categories: userList?.modulesNameList,
              labels: {
                formatter: function (val) {
                  return val
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Puan`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        /> */}
        {/* <StackedGraph
          type={'bar'}
          series={[
            {
              name: 'Kadın',
              data: userList?.womenHAPAScore ?? [],
            },
            {
              name: 'Erkek',
              data: userList?.menHAPAScore ?? [],
            },
            {
              name: 'Diğer',
              data: userList?.otherHAPAScore ?? [],
            },
          ]}
          options={{
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0,
                  },
                },
              },
            ],
            plotOptions: {
              bar: {
                horizontal: false,

                borderRadius: 10,
                dataLabels: {
                  orientation: 'horizontal',
                  // total: {
                  //   enabled: true,
                  //   offsetX: 0,
                  //   style: {
                  //     fontSize: '13px',
                  //     fontWeight: 900
                  //   }
                  // }
                },
              },
            },
            stroke: {
              width: 1,
              colors: ['#fff'],
            },
            title: {
              text: 'HAPA ORTALAMA GRAFİK',
            },
            xaxis: {
              categories: userList?.modulesNameList,
              labels: {
                formatter: function (val) {
                  return val
                },
              },
            },
            yaxis: {
              title: {
                text: undefined,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val.toString()} Puan`
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
              offsetX: 40,
            },
          }}
        /> */}
      </div>
    </>
  )
}
export {Consultant}
